import type {AxiosError} from "axios";

type LoginErrorBody = {
  message?: string;
  error_code?: string;
  code?: string;
};

const LOGIN_ERROR_MESSAGES: Record<string, string> = {
  dispatch_center_inactive:
    "This dispatch center is inactive. Contact your administrator.",
  dispatch_center_ip_blocked:
    "Login is not allowed from this network for your dispatch center.",
};

export function parseLoginErrorMessage(error: unknown): string | null {
  const axiosError = error as AxiosError<LoginErrorBody>;
  const status = axiosError.response?.status;
  if (status !== 423 && status !== 403) return null;

  const body = axiosError.response?.data;
  const code = body?.error_code ?? body?.code;
  if (!code) return body?.message ?? null;

  return LOGIN_ERROR_MESSAGES[code] ?? body?.message ?? null;
}
